import React from 'react';

export default function MarketinIcon() {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clip-path='url(#clip0_8281_8736)'>
        <path
          d='M1.36719 1.3667H2.70052L4.47385 9.6467C4.53891 9.94994 4.70763 10.221 4.951 10.4133C5.19436 10.6055 5.49712 10.7069 5.80719 10.7H12.3272C12.6306 10.6995 12.9248 10.5956 13.1612 10.4053C13.3976 10.215 13.5619 9.94972 13.6272 9.65337L14.7272 4.70003H3.41385M6.00049 14C6.00049 14.3682 5.70201 14.6667 5.33382 14.6667C4.96563 14.6667 4.66716 14.3682 4.66716 14C4.66716 13.6318 4.96563 13.3333 5.33382 13.3333C5.70201 13.3333 6.00049 13.6318 6.00049 14ZM13.3338 14C13.3338 14.3682 13.0353 14.6667 12.6672 14.6667C12.299 14.6667 12.0005 14.3682 12.0005 14C12.0005 13.6318 12.299 13.3333 12.6672 13.3333C13.0353 13.3333 13.3338 13.6318 13.3338 14Z'
          stroke='url(#paint0_linear_8281_8736)'
          stroke-width='1.25'
          stroke-linecap='round'
          stroke-linejoin='round'
        />
      </g>
      <defs>
        <linearGradient
          id='paint0_linear_8281_8736'
          x1='1.26396'
          y1='-1.36601'
          x2='10.9028'
          y2='12.826'
          gradientUnits='userSpaceOnUse'
        >
          <stop stop-color='white' />
          <stop offset='1' stop-color='white' stop-opacity='0.65' />
        </linearGradient>
        <clipPath id='clip0_8281_8736'>
          <rect width='16' height='16' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
}
